<script lang="ts">
	import { onMount } from "svelte"

	let search = ``

	onMount(() => {
		search = new URLSearchParams(window.location.search).get(`s`) || ``
	})
</script>

<form role="search" method="get" class="searchform" action="/">
	<input type="text" name="s" placeholder="Search for Products" value={search}>
	<input type="hidden" name="post_type" value="product">
	<input type="hidden" name="paged" value="0">

	<button type="submit" aria-label="Search"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="6"/><path d="M21 21l-6.0-6.0"/></svg></button>
</form>

<style>
	form {
		position: relative;
		width: 100%;
	}
	input[type="text"] {
		width: 100%;
		background-color: #111;
		border: 1px solid #666;
		padding: 0 10px;
		border-radius: 5px;
		font-family: 'Protipo Wide', sans-serif;
		color: #fff;
		line-height: 38px;
		font-size: 0.8rem;
		font-weight: 400;
	}
	input[type="text"]::placeholder {
		color: #999;
	}
	button {
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;
		background-color: transparent;
		border: 0;
		padding: 0;
		width: 40px;
		color: #cecece;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
